<template>
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    @close="onDialogClose"
    title="Khôi phục dữ liệu"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col>
          <field-group
            v-model="dialog.data.file"
            :error-messages="dialog.error.file"
            typeInput="field-file-input"
            accept="zip"
            title="Tải file backup"
          >
          </field-group>
        </v-col>
      </v-row>
    </base-form>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
        Khôi phục
      </base-button>
    </template>
  </base-dialog>
</template>
<script>
import { API_BACKUP } from '@api'
import JsonToFormData from '@/src/utils/JsonToFormData'
import { ConfirmBuilder } from '@utils'
export default {
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      error: {},
    },
  }),
  methods: {
    open() {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.$set(this.dialog, 'data', {})
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return

      let confirm = new ConfirmBuilder()
      confirm
        .setTitle('confirm.title')
        .setOption({
          color: 'error',
        })
        .addText(
          `Hành động này sẽ khôi phục toàn bộ dữ liệu lớp, bản đồ, trình bày thuộc tính, ... từ file backup`
        )
        .setApplyText('Xác nhận')

      if (await confirm.confirm()) {
        this.dialog.loading = true
        let data = JsonToFormData(this.dialog.data)

        let res = await API_BACKUP.restore(data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
        this.dialog.loading = false
      }
    },
  },
}
</script>
